// NyraRentalForm.jsx
import React, { useRef } from 'react';
import './TenantVerificationForm.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import PrintBtn from './PrintByt';
import { cleanName, extractAddressParts } from '../../utils/common';

const NyraRentalForm = () => {
  const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };
    const location = useLocation();
  const user = location.state;

   const navigate = useNavigate();
      const handleClick = () => {
      
      navigate('/Rental-manager', {
        state: {mobileNumber:user?.tenantUserName},
      })
    }

     const docList = user?.docList || [];

   const tenantDoc =   docList.find(item => (item?.docName || "").toLowerCase() === "tenant photo" );

   
      const  [permanentAddress, state1, District] = extractAddressParts(user?.permanentAddress || "")
  

  return (
   <div className='NyraRentalFormWrapper'>
      <div className="flex gap-10 noPrint" style={{cursor:"pointer"}} onClick={handleClick}>
            <div 
            className="noPrint"
            style={{cursor:"pointer"}}
            ><i className="fa-solid fa-arrow-left"></i></div>
             <strong>Back</strong>

          </div>

      <div></div>
        <div className="form-wrapper" ref={printRef}>
            <PrintBtn />
      <div className="form-header">
              <div  className={`photo-placeholder ${tenantDoc?.docLink ? "img-photo" : ""}`}>
                {
                  tenantDoc?.docLink ?
                  <img src={tenantDoc?.docLink} alt=""  style={{width:"100%"}}/>
                  :"Photo"
                }
             
                </div>
        <h1>NYRA HOME’S</h1>
        <h3>TERMS AND CONDITIONS FORM</h3>
      </div>

      <div className="form-body">
        <div className="row">
          <span className="label">Name:</span>
          <span className="value" contentEditable={true}>{user?.tenantFullName || ""}</span>
        </div>
        <div className="row">
          <span className="label">Father Name:</span>
          <span className="value" contentEditable={true}>{cleanName(user?.careOf || "")}</span>
        </div>
        <div className="row">
          <span className="label">Address:</span>
          <span className="value" contentEditable={true}>{permanentAddress || ""}</span>
        </div>
         <div className="row">
         
          <span className="value" contentEditable={true}></span>
        </div>
        <div className="row">
          <span className="label">City:</span>
          <span className="value" contentEditable={true}>{District}</span>
          <span className="label">State:</span>
          <span className="value" contentEditable={true}>{state1}</span>
          <span className="label">Pin Code:</span>
          <span className="value" contentEditable={true}>{user?.pinCode || ""}</span>
        </div>
        <div className="row">
          <span className="label">Mobile No:</span>
          <span className="value" contentEditable={true}>{user?.mobileNumber || ""}</span>
        </div>
        <div className="row">
          <span className="label">Company Name:</span>
          <span className="value" contentEditable={true}></span>
        </div>
        <div className="row">
          <span className="label">Rent:</span>
          <span className="value" contentEditable={true}></span>
          <span className="label">Deposit:</span>
          <span className="value" contentEditable={true}></span>
          <span className="label" >Room No:</span>
          <span className="value" contentEditable={true}></span>
        </div>
        <div className="row">
          <span className="label">Month Cycle Date:</span>
          <span className="value" contentEditable={true}></span>
          <span className="label">To:</span>
          <span className="value" contentEditable={true}></span>
          <span className="value" contentEditable={true}></span>
        </div>

          <div className="terms">
            <p>The following terms and conditions apply to the guests once they move into our PG.</p>
          </div>

        <div className="terms">
          <p>1. Month's Rent in Advance.</p>
          <p>2. Payment Mode Will Be in CASH OR IMPS Only.</p>
          <p>3. Notice period would be of 1 MONTH (of leaving the room) (In written) ON RENT DATE (1 to 5).</p>
          <p>4. Minimum locking period - <span style={{color:"#000",display:"inline-block", minWidth:"200px", borderBottom: "1px dotted #000"}} contentEditable={true}></span></p>
          <p>5. Rent and electricity to be paid before 5th of every month else fine of Rs. 200 per day in case of delay in payment</p>
          <p>6. The Owner reserves the right to check the rooms at any time during the day.</p>
          <p>7. Security deposit shall be refunded 1 week post vacating the room.</p>
          <p>8. DOCUMENTS: One photo ID card (passport, voting card, Aadhar Card) only.</p>
        </div>

        <div className="signature-section">
          <div>
            
            <p className="signature-label">Candidate Signature</p>
          </div>
          <div>
            <p>___________</p>
            <p className="signature-label">Witness</p>
          </div>
       
        </div>
      </div>

   
    </div>
   </div>
  );
};

export default NyraRentalForm;
